import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/auth-context";
import { CenterSpinner } from "@/components/common/States";

const HOME = {
  customer: "/",
  vendor: "/vendor",
  driver: "/driver",
  admin: "/admin",
};

export function homeFor(role) {
  return HOME[role] || "/";
}

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <CenterSpinner className="min-h-screen" />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

export function RequireRole({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <CenterSpinner className="min-h-screen" />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}
